import './updateModal.scss'
import { useState, useEffect } from 'react'
import icons from '../../../../helpers/iconMenu'
import Text from '../../../../components/text-component/Text'
import Icon from '../../../../components/icon-component/Icon'
import { getStaticText } from '../../../../lables/lablesService'
import Button from '../../../../components/button-component/Button'

/**
 * Update modal form component
 * 
 * @params isEdit - boolean
 * @params errors - variable
 * @params handleUpdate - func
 * @params showUpdateModal - func
 * @params updatedValue - variable
 * @params updateRowValue - func
 * @params showUpdateModal - func
 * @params handleValidation - func
 * 
 * @returns JSX
 */
const UpdateModal = ({
    errors,
    handleUpdate,
    updatedValue,
    fetchPageList,
    updateRowValue,
    handleValidation,
    closeUpdateModal,
    successfulUpdateMsg,
    unsuccessfulUpdateMsg,
    setSuccessUpdatefulMsg,
    setUnsuccessfulUpdateMsg,
}) => {

    //State for mount component
    const [didMount, setDidMount] = useState(false);
    //State for edit rows data
    const [editFormData, setEditFormData] = useState({
        id: updatedValue.id,
        iso: updatedValue.iso,
        flag: updatedValue.flag,
        name: updatedValue.name,
        active: updatedValue.active,
        is_default: updatedValue.is_default
    });
    //State for disabled button
    const [disabledBtn, setDisabledBtn] = useState(false);
    //State for input active checked
    const [isCheckedActive, setIsCheckedActive] = useState(updatedValue.active);
    //State for show/hide error message
    const [isAlertSuccessfulVisible, setIsAlertSuccessfulVisible] = useState(false);
    //State for input default checked
    const [isCheckedDefault, setIsCheckedDefault] = useState(updatedValue.is_default);
    //State for show/hide error message
    const [isAlertUnsuccessfulVisible, setIsAlertUnsuccessfulVisible] = useState(false);

    useEffect(() => {
        let timeout;

        if (unsuccessfulUpdateMsg) {
            setIsAlertUnsuccessfulVisible(true)

            timeout = window.setTimeout(() => {
                setIsAlertUnsuccessfulVisible(false);
                setUnsuccessfulUpdateMsg("");
                setDisabledBtn(prev => !prev);
            }, 3000)
        }

        return () => window.clearTimeout(timeout);

    }, [unsuccessfulUpdateMsg, setUnsuccessfulUpdateMsg])

    useEffect(() => {
        let timeout;

        if (successfulUpdateMsg) {
            setIsAlertSuccessfulVisible(true)

            timeout = window.setTimeout(() => {
                setIsAlertSuccessfulVisible(false);
                setSuccessUpdatefulMsg("");
                closeUpdateModal();
            }, 3000)
        }

        return () => window.clearTimeout(timeout);

    }, [successfulUpdateMsg, setSuccessUpdatefulMsg, closeUpdateModal])

    /**
    * The method changes the active input value 
    * 
    * @params event 
    */
    const handleChangeCheckedActive = event => {
        setIsCheckedActive(event.target.checked);
        setEditFormData(prev => ({
            ...prev,
            active: event.target.checked
        }))
    };

    /**
    * The method changes the default input value 
    * 
    * @params  event 
    */
    const handleChangeCheckedDefault = event => {
        setIsCheckedDefault(event.target.checked);
        setEditFormData(prev => ({
            ...prev,
            is_default: event.target.checked
        }))
    };

    /**
     * Method submit edit form data
     * 
     * @params event 
     */
    const handleEditFormSubmit = async event => {
        event.preventDefault();

        if (disabledBtn) return;

        setDisabledBtn(prev => !prev);

        if (handleValidation(editFormData)) {

            await updateRowValue(editFormData);

            handleUpdate(editFormData)
            setEditFormData(editFormData)

            await fetchPageList();
        } else {

            setDisabledBtn(prev => !prev);
        }
    };

    /**
     * The method of changing the value of the input name field
     * 
     * @params event 
     */
    const handleEditFormChangeName = event => {
        event.preventDefault();
        setEditFormData(prev => ({
            ...prev,
            name: event.target.value.trim()
        }));
    };

    /**
     * The method of changing the value of the input iso field
     * 
     * @paramі event 
     */
    const handleEditFormChangeIso = event => {
        event.preventDefault();
        setEditFormData(prev => ({
            ...prev,
            iso: event.target.value.trim()
        }));
    };

    /**
     * The method of changing the value of the input flag field
     * 
     * @paramі event 
     */
    const handleEditFormChangeFlag = event => {
        event.preventDefault();
        setEditFormData(prev => ({
            ...prev,
            flag: event.target.value.trim()
        }));
    };

    useEffect(() => {
        setDidMount(true);
        return () => setDidMount(false);
    }, [])

    if (!didMount) {
        return null;
    }

    return (
        <div className="d-flex justify-content-center align-items-center modal_open">
            <form className="p-4 pt-2 pb-2 modal_language" onSubmit={handleEditFormSubmit}>
                <Text
                    content={getStaticText('update_modal_title')}
                    text_style={"text-center text-danger pt-4 h5"}
                >
                    <Icon
                        onClick={closeUpdateModal}
                        icon_style={icons.lng_form_remove}
                        icon_className={"lng_icon_remove"}
                    />
                </Text>

                {/* Render success unsuccess error message */}
                {
                    isAlertUnsuccessfulVisible &&
                    (unsuccessfulUpdateMsg &&
                        <Text
                            content={unsuccessfulUpdateMsg}
                            text_style={"alert alert-danger p-0 pt-1 pb-1 text-center h6"}
                        />
                    )
                }
                {
                    isAlertSuccessfulVisible &&
                    (successfulUpdateMsg &&

                        <Text
                            content={successfulUpdateMsg}
                            text_style={"alert alert-success p-0 pt-1 pb-1 text-center h6"}
                        />
                    )
                }

                <Text
                    content={getStaticText('add_form_name')}
                    text_style={"text-left d-flex ml-1 mb-0 h6"}
                />

                {/* Show/hide error msg */}
                <p className='h6 error_msg'>
                    {errors && errors['iso']}
                </p>
                <input
                    type="text"
                    name="name"
                    autoComplete="off"
                    value={editFormData.name}
                    onChange={handleEditFormChangeName}
                    className="form-control shadow-none mt-1"
                    placeholder={getStaticText('add_form_placeholder')}
                />

                <Text
                    content={getStaticText('add_form_ico')}
                    text_style={"text-left d-flex ml-1 mb-0 h6 pt-2"}
                />
                {/* Show/hide error msg */}
                <p className='h6 error_msg'>
                    {errors && errors['name']}
                </p>
                <input
                    type="text"
                    name="iso"
                    autoComplete="off"
                    value={editFormData.iso}
                    onChange={handleEditFormChangeIso}
                    className="form-control shadow-none mt-1"
                    placeholder={getStaticText('add_form_placeholder')}
                />

                <Text
                    content={getStaticText('add_form_flag')}
                    text_style={"text-left d-flex ml-1 mb-0 h6 pt-2"}
                />
                {/* Show/hide error msg */}
                <p className='h6 error_msg'>
                    {errors && errors['flag']}
                </p>
                <input
                    type="text"
                    name="flag"
                    autoComplete="off"
                    value={editFormData.flag}
                    onChange={handleEditFormChangeFlag}
                    className="form-control shadow-none mt-1"
                    placeholder={getStaticText('add_form_placeholder')}
                />

                <Text
                    content={getStaticText('add_defoult_lng')}
                    text_style={"text-left d-flex ml-1 mb-0 h6 pt-2"}
                />
                <span className='add_checkbox'>
                    <input
                        type={"checkbox"}
                        name="is_default"
                        className='checkbox'
                        checked={isCheckedDefault}
                        onChange={handleChangeCheckedDefault}
                    />
                    <span className='m-1'>{getStaticText('checkbox_default')}</span>
                </span>

                <Text
                    content={getStaticText('add_active_lng')}
                    text_style={"text-left d-flex ml-1 mb-0 h6 pt-2"}
                />
                <span className='add_checkbox'>
                    <input
                        name="active"
                        type={"checkbox"}
                        className='checkbox'
                        checked={isCheckedActive}
                        onChange={handleChangeCheckedActive}
                    />
                    <span className='m-1'>{getStaticText('checkbox_default')}</span>
                </span>
                <div className='text-center'>
                    <Button
                        type='submit'
                        bgcolor={"success"}
                        btn_disabled={disabledBtn}
                        btn_styles={"btn-active text-white shadow-none mt-2 mb-2"}
                        label={disabledBtn ? getStaticText('loading_btn') : getStaticText('lng_btn_update')}
                    />
                </div>
            </form>
        </div>
    )
}

export default UpdateModal;